import React from 'react';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { AxiosResponse, CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';

const columns = [
  { field: 'timestamp', headerName: 'Timestamp', width: 200, flex: 0.5 },
  { field: 'flag', headerName: 'Flag', width: 200, flex: 0.5 },
  { field: 'pid', headerName: 'Pid', width: 200, flex: 0.5 },
];

interface MessagesInfo {
  pid: number;
  timestamp: string;
  flag: string;
}

let index = 0;
function createData(info: MessagesInfo) {
  index += 1;
  return { id: index, ...info };
}

const PlayerMessages = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices
      .get<MessagesInfo[]>(`/admin/messages/player/${requestPid}`, { cancelToken })
      .catch((error) => {
        if (error && error.response && error.response.status === 404) return { ...error.response, data: [] } as AxiosResponse<MessagesInfo[]>;
        throw error;
      });
  }

  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });
  const rows = responseData?.map(createData) || [];
  // const rows = responseData || [];

  return (
    <>
      <TabTableContainer>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default PlayerMessages;
